import React from 'react';
import Memories from '../components/Memories/Memories';

export default function MemoriesPage() {
  return <Memories />;
}
